import queryString, { ParsedQuery } from 'query-string';

export class UrlParameterLoader {
  private urlParams: ParsedQuery<string>;
  private readonly keyForSessionStorage = 'INITIAL_URL_PARAMS';

  constructor(private readonly locationSearch: string) {}

  parseUrlAndPersist(): void {
    this.parseUrl();
    sessionStorage.setItem(this.keyForSessionStorage, JSON.stringify(this.urlParams));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getParameter(): any {
    return JSON.parse(sessionStorage.getItem(this.keyForSessionStorage));
  }

  /**
   * Removes the Query String from URL.
   * @example http://url.de/?key1=value1#key1=value1 will be transformed to http://url.de/#key1=value1
   *
   * @param {number} url The Url to be processed
   * @return {string} The Url without query string
   */
  removeQueryStringFromUrl(url: string): string {
    const base = url.split('?')[0];
    const queryStringIncludingAnchor = url.split('?')[1];
    let anchor = '';
    if (queryStringIncludingAnchor?.split('#')[1]) {
      anchor = '#' + queryStringIncludingAnchor.split('#')[1];
    }
    return base + anchor;
  }

  private parseUrl(): void {
    this.urlParams = queryString.parse(this.locationSearch);
  }
}
